module.exports = __webpack_public_path__ + "static/media/t23.fd308202.jpg";